import axios from "axios";

export default {
    read: (mode, ctrl) => axios.get(`/api/app_tokens/read/${mode}`, ctrl && { signal: ctrl.signal }),
    // readRecover: (ctrl) => axios.get("/api/roles/read_recover", ctrl && { signal: ctrl.signal }),
    // find: (id, ctrl) => axios.get(`/api/roles/find/${id}`, ctrl && { signal: ctrl.signal }),
    create: (obj, ctrl) => axios.post("/api/app_tokens/create", obj, ctrl && { signal: ctrl.signal }),
    update: (obj, ctrl) => axios.post("/api/app_tokens/update", obj, ctrl && { signal: ctrl.signal }),
    delete: (id, ctrl) => axios.get(`/api/app_tokens/delete/${id}`, ctrl && { signal: ctrl.signal }),
    recover: (id, ctrl) => axios.get(`/api/app_tokens/recover/${id}`, ctrl && { signal: ctrl.signal }),
    generate: (ctrl) => axios.get("/api/app_tokens/generate", ctrl && { signal: ctrl.signal }),
};
